// Formatações e regras de tela compartilhadas pela Baixa de Pagamento
import moment from "moment";

export const dataBR = (d) => (d ? moment(d).format("DD/MM/YYYY") : "-");

export const hojeISO = () => moment().format("YYYY-MM-DD");

// Valor digitado ("1.234,56", "1234.56", "1234,5") em número; vazio ou inválido = 0
export const numero = (v) => {
    if (typeof v === "number") return Number.isFinite(v) ? v : 0;
    let t = String(v ?? "").trim();
    if (!t) return 0;
    if (t.includes(",")) t = t.replace(/\./g, "").replace(",", ".");
    const n = parseFloat(t);
    return Number.isFinite(n) ? n : 0;
};

export const arredondar = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

// Texto para dentro do aviso do SweetAlert (que monta HTML)
export const escaparHtml = (t) => String(t ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

// Cor do chip de situação da parcela ou do débito (MUI Chip com contorno: o tema escuro clareia sozinho)
export const corDaSituacao = (situacao) => ({
    "Paga": "success",
    "Em atraso": "error",
    "Paga em parte": "warning",
    "Baixado em parte": "warning",
    "Em aberto": "info",
    "Cancelada": "secondary",
}[situacao] || "info");

export const SITUACAO_BOLETO = {
    1: "Emitido",
    2: "Aguardando registro",
    3: "Registrado",
    4: "Rejeitado",
    5: "Pago",
    6: "Aguardando cancelamento",
    7: "Cancelado",
};

// Diferença entre o valor pago e o saldo do item: sobra = acréscimo; falta = desconto (o item fica quitado) ou, no
// débito avulso com "quitar" desligado, o que continua em aberto (baixa parcial: o backend deixa o débito como
// Baixado Parcial com o saldo que sobrou). A parcela de acordo sempre quita.
export const diferenca = (saldo, valorPago, quitar = true) => {
    const d = arredondar(numero(valorPago) - (saldo || 0));
    const falta = d < 0 ? -d : 0;
    return { desconto: quitar ? falta : 0, acrescimo: d > 0 ? d : 0, restante: quitar ? 0 : falta };
};
